import type { TemplateEvidence } from '../schemas/onboarding';

export type UkTemplateKind = 'accounts' | 'confirmationStatement' | 'hmrcInternalTarget';

export function ukTemplateKind(serviceType: string, jurisdiction: string | null): UkTemplateKind | null {
  if (jurisdiction !== 'UK') return null;
  const service = serviceType.trim().toLowerCase().replace(/\s+/g, ' ');
  if (['companies house filing', 'companies house accounts filing'].includes(service)) return 'accounts';
  if (['confirmation statements', 'confirmation statement'].includes(service)) return 'confirmationStatement';
  return service === 'hmrc filing' ? 'hmrcInternalTarget' : null;
}

export function addUkCalendarMonths(iso: string, months: number, monthEnd = true): string {
  const date = new Date(`${iso.slice(0, 10)}T00:00:00.000Z`);
  const day = date.getUTCDate(), sourceMonth = date.getUTCMonth();
  const last = new Date(date); last.setUTCMonth(sourceMonth + 1, 0);
  const isMonthEnd = monthEnd && day === last.getUTCDate();
  date.setUTCDate(1); date.setUTCMonth(sourceMonth + months);
  const targetLast = new Date(date); targetLast.setUTCMonth(date.getUTCMonth() + 1, 0);
  date.setUTCDate(isMonthEnd ? targetLast.getUTCDate() : Math.min(day, targetLast.getUTCDate()));
  return date.toISOString().slice(0, 10);
}

export function ukTemplateDates(registry: TemplateEvidence['ukRegistry'], serviceType: string, jurisdiction: string | null): { endDate: string; dueDate: string } | null {
  const kind = ukTemplateKind(serviceType, jurisdiction), pair = kind && registry ? registry[kind] : null;
  return pair?.endDate && pair.dueDate ? { endDate: pair.endDate, dueDate: pair.dueDate } : null;
}

export function ukTemplateDateHint(serviceType: string, jurisdiction: string | null): string | null {
  const kind = ukTemplateKind(serviceType, jurisdiction);
  return kind === 'hmrcInternalTarget' ? 'HMRC Filing: firm internal completion target — 9 calendar months after the accounts period end; not the statutory Corporation Tax return deadline.' : kind === 'confirmationStatement' ? 'Confirmation statement: published review date and filing due date; independent of the accounts financial year.' : kind === 'accounts' ? 'Companies House accounts: published accounts period end and filing due date.' : null;
}
